module.exports = __webpack_public_path__ + "statics/img/MultiWarehouse-3.c71761b5.png";